module.exports = __webpack_public_path__ + "img/landing-image.ef5c04b2.png";